import { defineComponent, onMounted, ref, watch } from 'vue';
import axios from 'axios';
import InlineSvg from 'vue-inline-svg';
export default defineComponent({
    name: 'event-list',
    props: {
        getItemsUrl: String,
        date: String,
        title: String,
        cityCountry: String,
        additional: String,
        portfolio: String,
        selectedPortfolio: {
            type: Number,
            required: true
        }
    },
    components: {
        InlineSvg
    },
    setup(props) {
        let isLoading = ref(false), items = ref([]), filteredItems = ref([]);
        let filter = ref({ portfolio: props.selectedPortfolio });
        const fetchItems = () => {
            isLoading.value = true;
            items.value = [];
            return axios.get(props.getItemsUrl).then((response) => {
                items.value = response.data;
                filterItems();
                isLoading.value = false;
            }).catch((error) => {
                console.error('Oops an error occurred: ', error);
                isLoading.value = false;
            });
        };
        const filterItems = () => {
            filteredItems.value = items.value.filter((event) => {
                if (filter.value.portfolio !== 0) {
                    const itemsArray = Object.values(event.portfolio);
                    return itemsArray.some(item => {
                        return item.uid === filter.value.portfolio;
                    });
                }
                return true;
            });
        };
        const convertDate = (date) => {
            const twoHoursInSeconds = 7200;
            const newDate = new Date((parseInt(date) + twoHoursInSeconds) * 1000);
            return `${String(newDate.getUTCDate()).padStart(2, '0')}.${String(newDate.getUTCMonth() + 1).padStart(2, '0')}.${newDate.getUTCFullYear()}`;
        };
        const portfolioJoin = (items) => {
            const itemsArray = Object.values(items);
            return itemsArray.map((item) => {
                return item.title;
            }).join(", ");
        };
        onMounted(() => {
            fetchItems();
        });
        watch(filter.value, () => {
            filterItems();
        }, { deep: true });
        return {
            isLoading, filteredItems, convertDate, props, filter, portfolioJoin
        };
    }
});
